function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "AA34254A-C01B-4007-9EB0-E0170D9E281F");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-780.000000, -2406.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Buttons/Small/Primary-w-Icon-Copy",
  transform: "translate(768.000000, 2398.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(12.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Swap",
  transform: "translate(0.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.541698,7.48011055 C5.70798386,7.65337306 5.72876959,7.91442228 5.6040552,8.10963147 L5.541698,8.18881364 L3.64431768,10.166 L10.5191889,10.1655379 C10.7959547,10.1655379 11.0203177,10.3899009 11.0203177,10.6666667 C11.0203177,10.9434324 10.7959547,11.1677954 10.5191889,11.1677954 L3.64531768,11.168 L5.541698,13.1445197 C5.73173898,13.342534 5.73173898,13.6552085 5.541698,13.8532228 C5.36143823,14.0410455 5.06304843,14.0471765 4.87522572,13.8669167 L4.86153181,13.8532228 L4.86153181,13.8532228 L2.48331768,11.376 L2.48095013,11.3779775 L2.46533404,11.3617063 C2.45212619,11.3479443 2.4393881,11.3338988 2.42711976,11.3195902 L2.31090858,11.1955862 C2.18154645,11.0607966 2.14024196,10.8728778 2.18699512,10.7041607 C2.17967303,10.4870397 2.24277872,10.2674385 2.37657286,10.0829914 L2.46533404,9.97684264 L4.86153181,7.48011055 L4.87522572,7.46641664 L4.87522572,7.46641664 C5.06304843,7.28615687 5.36143823,7.29228784 5.541698,7.48011055 Z M10.1452863,2.14677722 C10.3255461,1.95895451 10.6239359,1.95282354 10.8117586,2.13308331 C10.8164166,2.13755368 10.8209822,2.14211928 10.8254525,2.14677722 L10.8254525,2.14677722 L13.2216503,4.6435093 L13.3104115,4.74965802 C13.4442056,4.93410515 13.5073113,5.15370637 13.4999892,5.37082734 C13.5467424,5.53954451 13.5054379,5.72746324 13.3760758,5.86225287 L13.3760758,5.86225287 L13.2598646,5.98625683 L13.2598646,5.98625683 L13.2216503,6.02837293 L13.2060342,6.04464421 L13.2036667,6.04266667 L10.8254525,8.51988945 C10.8209822,8.52454738 10.8164166,8.52911298 10.8117586,8.53358336 C10.6239359,8.71384313 10.3255461,8.70771216 10.1452863,8.51988945 C9.95524537,8.32187516 9.95524537,8.00920066 10.1452863,7.81118636 L10.1452863,7.81118636 L12.0416667,5.83466667 L5.16779543,5.83446209 C4.89102965,5.83446209 4.66666667,5.61009911 4.66666667,5.33333333 C4.66666667,5.05656756 4.89102965,4.83220457 5.16779543,4.83220457 L5.16779543,4.83220457 L12.0426667,4.83266667 L10.1452863,2.8554803 L10.0829292,2.77629814 C9.95821476,2.58108895 9.97900049,2.32003972 10.1452863,2.14677722 Z",
  id: "Combined-Shape",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 16,
  height: 16
}))))));

var SvgIconSwap = function SvgIconSwap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSwap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Swap.16f8c7ab.svg";
export { ForwardRef as ReactComponent };